import { useTranslation } from "react-i18next";

const Service = ({ icon, titleKey, textKey }) => {
  const { t } = useTranslation();

  return (
    <article className='service'>
      <i className={icon}></i>
      <h4 style={{ marginTop: '1rem' }}>{t(titleKey)}</h4>
      <div className="underline"></div>
      <p className='service-text'>{t(textKey)}</p>
    </article>
  );
}
export default Service;
